import React from "react"
import { Link } from "gatsby"
import * as styles from "./footer.module.scss"

import wolfireLogoSrc from "./wolfire-games-logo-lg.png"
import Divider from "../ui/divider/divider";
import Container from "../container/container";
import Newsletter from "../newsletter/newsletter";
import Social from "../social/social";

const Footer = () => {
  return (
    <footer className={styles.root}>
      <Link className={styles.logo} to="/">
        <img src={wolfireLogoSrc} alt="Wolfire Games logo" height="103" width="87" />
      </Link>
      <Container className={styles.container}>
        <Divider />
        <div className={styles.top}>
          <Newsletter />
          <Divider className={styles.hr} />
          <Social className={styles.social} />
        </div>
        <Divider />
        <nav className={styles.nav}>
          <ul>
            <li>
              © {new Date().getFullYear()}&nbsp;Wolfire Games
            </li>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/games">Games</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy</Link>
            </li>
            <li>
              Site designed by&nbsp;<a href="http://www.fullyillustrated.com" target="_blank">
                Fully Illustrated
              </a>
            </li>
          </ul>
        </nav>
      </Container>
    </footer>
  )
}

export default Footer
